import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3C11 2.44772 10.5523 2 10 2L4 3C3.44771 3 3 3.44772 3 4V20C3 20.5523 3.44771 21 4 21L10 22C10.5523 22 11 21.5523 11 21V20.75H15C15.1989 20.75 15.3897 20.671 15.5303 20.5303C15.671 20.3897 15.75 20.1989 15.75 20V16C15.75 15.5858 15.4142 15.25 15 15.25C14.5858 15.25 14.25 15.5858 14.25 16V19.25H11V4.75L14.25 4.75V8C14.25 8.41421 14.5858 8.75 15 8.75C15.4142 8.75 15.75 8.41421 15.75 8V4C15.75 3.58579 15.4142 3.25 15 3.25L11 3.25V3ZM18.5466 8.46967C18.2537 8.76256 18.2537 9.23744 18.5466 9.53033L20.2663 11.25H14C13.5858 11.25 13.25 11.5858 13.25 12C13.25 12.4142 13.5858 12.75 14 12.75H20.1124L18.5466 14.3158C18.2537 14.6087 18.2537 15.0836 18.5466 15.3765C18.8395 15.6694 19.3144 15.6694 19.6073 15.3765L22.5303 12.4534C22.8232 12.1605 22.8232 11.6856 22.5303 11.3927L19.6073 8.46967C19.3144 8.17678 18.8395 8.17678 18.5466 8.46967Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
